
import BaseService from "@/boot/BaseService";
class TotvsLogisticaService extends BaseService {
    constructor() {
        super(null, "/totvs-logistica");
    }
    async getHorariosDisponibles(params) {
        return await this.get("/horarios-disponibles", params);
    }
    async storeAgenda(formData) {
        return await this.post("/agenda", formData);
    }
    async getAgendaByDate(params) {
        return await this.get("/agenda-by-date", params);
    }
    async getTotalAgendaByPedido(params) {
        return await this.get("/total-agenda-by-pedido", params);
    }
    async getProcessoRodoviario(params) {
        return await this.get("/processo-rodoviario", params);
    }
    async getAgendaByPedido(params) {
        return await this.get("/agenda-by-pedido", params);
    }
}

export default new TotvsLogisticaService();
